<template>
  <v-container style="z-index: 3">
    <v-row class="justify-center d-none" no-gutters>
      <v-col cols="12" class="text-center">
        <h2 class="text-blue">
          Loading your content. <br />
          Please wait ...
        </h2>
      </v-col>
    </v-row>
    <v-row class="justify-center" no-gutters>
      <v-col cols="12" class="text-center">
        <svg
          class="lds-dna"
          width="330px"
          height="330px"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
          style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%"
        >
          <circle cx="6.451612903225806" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-0.5s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="0s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#1d3f72;#5699d2;#1d3f72"
              dur="2s"
              repeatCount="indefinite"
              begin="-0.5s"
            />
          </circle>
          <circle cx="6.451612903225806" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.5s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-1s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#d8ebf9;#71c2cc;#d8ebf9"
              dur="2s"
              repeatCount="indefinite"
              begin="-0.5s"
            />
          </circle>
          <circle cx="16.129032258064512" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-0.7s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-0.2s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#1d3f72;#5699d2;#1d3f72"
              dur="2s"
              repeatCount="indefinite"
              begin="-0.7s"
            />
          </circle>
          <circle cx="16.129032258064512" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.7s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.2s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#d8ebf9;#71c2cc;#d8ebf9"
              dur="2s"
              repeatCount="indefinite"
              begin="-0.7s"
            />
          </circle>
          <circle cx="25.806451612903224" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-0.9s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-0.4s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#1d3f72;#5699d2;#1d3f72"
              dur="2s"
              repeatCount="indefinite"
              begin="-0.9s"
            />
          </circle>
          <circle cx="25.806451612903224" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.9s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.4s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#d8ebf9;#71c2cc;#d8ebf9"
              dur="2s"
              repeatCount="indefinite"
              begin="-0.9s"
            />
          </circle>
          <circle cx="35.48387096774193" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.1s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-0.6s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#1d3f72;#5699d2;#1d3f72"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.1s"
            />
          </circle>
          <circle cx="35.48387096774193" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-2.1s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.6s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#d8ebf9;#71c2cc;#d8ebf9"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.1s"
            />
          </circle>
          <circle cx="45.16129032258064" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.3s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-0.8s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#1d3f72;#5699d2;#1d3f72"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.3s"
            />
          </circle>
          <circle cx="45.16129032258064" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-2.3s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.8s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#d8ebf9;#71c2cc;#d8ebf9"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.3s"
            />
          </circle>
          <circle cx="54.838709677419345" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.5s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-1s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#1d3f72;#5699d2;#1d3f72"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.5s"
            />
          </circle>
          <circle cx="54.838709677419345" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-2.5s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-2s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#d8ebf9;#71c2cc;#d8ebf9"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.5s"
            />
          </circle>
          <circle cx="64.51612903225805" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.7s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.2s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#1d3f72;#5699d2;#1d3f72"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.7s"
            />
          </circle>
          <circle cx="64.51612903225805" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-2.7s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-2.2s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#d8ebf9;#71c2cc;#d8ebf9"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.7s"
            />
          </circle>
          <circle cx="74.19354838709677" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.9s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.4s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#1d3f72;#5699d2;#1d3f72"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.9s"
            />
          </circle>
          <circle cx="74.19354838709677" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-2.9s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-2.4s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#d8ebf9;#71c2cc;#d8ebf9"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.9s"
            />
          </circle>
          <circle cx="83.87096774193547" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-2.1s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.6s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#1d3f72;#5699d2;#1d3f72"
              dur="2s"
              repeatCount="indefinite"
              begin="-2.1s"
            />
          </circle>
          <circle cx="83.87096774193547" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-3.1s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-2.6s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#d8ebf9;#71c2cc;#d8ebf9"
              dur="2s"
              repeatCount="indefinite"
              begin="-2.1s"
            />
          </circle>
          <circle cx="93.54838709677418" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-2.3s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-1.8s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#1d3f72;#5699d2;#1d3f72"
              dur="2s"
              repeatCount="indefinite"
              begin="-2.3s"
            />
          </circle>
          <circle cx="93.54838709677418" cy="50" r="3">
            <animate
              attributeName="r"
              times="0;0.5;1"
              values="2.4000000000000004;3.5999999999999996;2.4000000000000004"
              dur="2s"
              repeatCount="indefinite"
              begin="-3.3s"
            />
            <animate
              attributeName="cy"
              keyTimes="0;0.5;1"
              values="32;68;32"
              dur="2s"
              repeatCount="indefinite"
              begin="-2.8s"
              keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
              calcMode="spline"
            />
            <animate
              attributeName="fill"
              keyTimes="0;0.5;1"
              values="#d8ebf9;#71c2cc;#d8ebf9"
              dur="2s"
              repeatCount="indefinite"
              begin="-2.3s"
            />
          </circle>
        </svg>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Loaders",
};
</script>

<style scoped>
h2 {
  font-size: 35px;
}
</style>
